import Vue from 'vue';
import { CompanyPaymentMethod, CompanyPaymentStatus, CompanyBankAccountType, CompanyContractStatus, CompanyUsingStatus } from '@/store/CompanyStore';
import { ConsoleType } from '@/store/ConsoleStore';

/* like 2019/04/15 */
Vue.filter('dateYMD', function(val: Date) {
    return `${val.getFullYear()}/${val.getMonth()+1}/${val.getDate()}`;
})
/* like 2019/04/15 12:34:56 */
Vue.filter('dateYMDHMS', function(val: Date) {
    const hour = val.getHours().toString().padStart(2, '0');
    const min = val.getMinutes().toString().padStart(2, '0');
    const sec = val.getSeconds().toString().padStart(2, '0');
    return `${val.getFullYear()}/${val.getMonth()+1}/${val.getDate()} ${hour}:${min}:${sec}`;
})
/* like 42,984 */
Vue.filter('commaSeparated', function(val: number) {
    return String(Math.round(val)).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
});

/* Company */
Vue.filter('CompanyPaymentMethod', function(val: CompanyPaymentMethod) {
    switch(val) {
        case CompanyPaymentMethod.AccountTransfer:
            return '口座振替';
        case CompanyPaymentMethod.CreditCard:
            return 'クレジットカード';
        case CompanyPaymentMethod.Bill: 
            return '請求書';
        default:
            return '未設定';
    }
});

Vue.filter('CompanyPaymentStatus', function(val: CompanyPaymentStatus) {
    switch(val) {
        case CompanyPaymentStatus.Normal:
            return '正常';
        case CompanyPaymentStatus.Delinquent:
            return '滞納';
    }
});

Vue.filter('CompanyBankAccountType', function(val: CompanyBankAccountType) {
    switch(val) {
        case CompanyBankAccountType.Normal:
            return '普通';
        case CompanyBankAccountType.Current:
            return '当座';
    }
});

Vue.filter('CompanyContractStatus', function(val: CompanyContractStatus) {
    const planMap = { 0: 'Aプラン', 1: 'Bプラン', 2: 'Cプラン' };
    const statusMap = { 1: '無料トライアル中', 0: '有料使用中', 2: '一時停止中' };

    if(val.plan === undefined || val.usage === CompanyUsingStatus.TrialStarted) return `${statusMap[val.usage]}`;
    else return `${statusMap[val.usage]}(${planMap[val.plan]})`;
}) 

Vue.filter('Money', function(val: number) {
    let str = val + "";
    if(str[0] == '-') str = str.substr(1);
    const offset = str.length % 3;
    let result = (val < 0 ? "-" : "") + str.substr(0, offset);
    for(let i = 0; i < Math.floor(str.length / 3); i++) {
        if(offset == 0 && i == 0) result += str.substr(offset + i * 3, 3);
        else result += "," + str.substr(offset + i * 3, 3);
    }

    return result + "円";
})

Vue.filter('ConsoleType', function(val: ConsoleType) {
    switch(val) {
        case ConsoleType.Gen1:
            return 'KIC102HD-DN(第一世代)';
        case ConsoleType.Gen2:
            return 'KIC104-DN(第二世代)';
        default:
            return '不明';
    }
});
